export default __webpack_public_path__ + "static/media/bullyPuppy.ada7acaa.png";